/**
 * Wrangle-pattern AI Agent — shared TypeScript types.
 *
 * Mirror of the schema introduced by
 * `supabase/migrations/20260503000000_ai_agent_sessions.sql`.
 */

/** Role tag persisted on every message row. */
export type AgentRole = 'user' | 'assistant' | 'tool';

/**
 * One conversation thread. `title` is nullable until the agent derives it
 * from the first user message (we set it on first appendMessage).
 */
export interface AgentSession {
  id:         string;
  userId:     string;
  title:      string | null;
  createdAt:  string;
  updatedAt:  string;
}

/** Database row shape for `ai_agent_sessions`. */
export interface AgentSessionRow {
  id:         string;
  user_id:    string;
  title:      string | null;
  created_at: string;
  updated_at: string;
}

/** One message inside a session. */
export interface AgentMessage {
  id:         string;
  sessionId:  string;
  role:       AgentRole;
  content:    string;
  ts:         string;
}

/** Database row shape for `ai_agent_messages`. */
export interface AgentMessageRow {
  id:         string;
  session_id: string;
  role:       AgentRole;
  content:    string;
  ts:         string;
}

/** Subset of message used when sending history to the edge function. */
export interface AgentHistoryItem {
  role:    'user' | 'assistant';
  content: string;
}

export function rowToSession(row: AgentSessionRow): AgentSession {
  return {
    id:        row.id,
    userId:    row.user_id,
    title:     row.title,
    createdAt: row.created_at,
    updatedAt: row.updated_at,
  };
}

export function rowToMessage(row: AgentMessageRow): AgentMessage {
  return {
    id:        row.id,
    sessionId: row.session_id,
    role:      row.role,
    content:   row.content,
    ts:        row.ts,
  };
}
